module.exports = __webpack_public_path__ + "static/media/2.6c5a78c2.JPG";